import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/lib/integration/react';
import 'reset-css';
import { ThemeProvider } from 'styled-components';

import AlertDialogs from '@/components/AlertDialogs';
import store, { persistor } from '@/utils/store';
import theme, { GlobalStyles } from '@/utils/theme';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { clearExpired } from './utils/storage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
    },
  },
});

const root = createRoot(document.getElementById('root')!);

clearExpired();

root.render(
  <StrictMode>
    <ReduxProvider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <GlobalStyles />
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryClientProvider>
          <AlertDialogs />
        </ThemeProvider>
      </PersistGate>
    </ReduxProvider>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
